<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-brand">
  <a routerLink="/home">
    <span class="brand">Provalt</span>
    <span class="brand-mini">P</span>
  </a>
</div>

<div class="flexbox flex-1">
  <!-- START TOP-LEFT TOOLBAR-->
  <ul class="nav navbar-toolbar">
    <li>
      <a class="nav-link sidebar-toggler js-sidebar-toggler" href="javascript:">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
    </li>
  </ul>
  <!-- END TOP-LEFT TOOLBAR-->

  <!-- START TOP-RIGHT TOOLBAR-->
  <ul class="nav navbar-toolbar">

    <li class="dropdown dropdown-user">
      <a class="nav-link dropdown-toggle link" data-toggle="dropdown">
        <span>{{ fullName }}</span>
      </a>

      <div class="dropdown-menu dropdown-arrow dropdown-menu-right admin-dropdown-menu">
        <div class="dropdown-arrow"></div>

        <div class="dropdown-header">
          <h5 class="font-strong text-white">{{ fullName }}</h5>
        </div>

        <div class="admin-menu-features">
          <a class="admin-features-item" routerLink="/profile">
            <em class="ti-user"></em>&nbsp;
            <span i18n="@@myAccount">My account</span>
          </a>

          <a class="admin-features-item" routerLink="/history">
            <em class="ti-agenda"></em>&nbsp;
            <span i18n="@@history">History</span>
          </a>
        </div>

        <div class="admin-menu-content">
          <div class="d-flex justify-content-end mt-3">
            <a class="d-flex align-items-end" routerLinkActive="active" (click)="authService?.logout()">
              <span i18n="@@logout">Logout</span>
              <em class="ti-shift-right ml-2 font-20"></em>
            </a>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <!-- END TOP-RIGHT TOOLBAR-->
</div>
